import React, { useState } from "react";
import Select from "react-select";

const MultiSelectDropdown = ({ options, placeholder, onChange, value }) => {
  const [selectedOptions, setSelectedOptions] = useState(() => {
    if (!value) return [];
    return Array.isArray(value) 
      ? value.map(val => typeof val === 'object' ? val : { value: val, label: val })
      : [];
  });
  const [searchInput, setSearchInput] = useState("");

  // Function to handle changes in selected options
  const handleSelectChange = (selected) => {
    setSelectedOptions(selected || []);
    // Call the parent's onChange handler if provided
    if (onChange) {
      onChange(selected);
    }
  };

  // Function to filter options based on search input
  const handleSearchChange = (inputValue) => {
    setSearchInput(inputValue);
  };

  // Filter the options based on search input
  const filteredOptions = options.filter((option) =>
    option.toLowerCase().includes(searchInput.toLowerCase())
  );

  // Custom styles for react-select component
  const customStyles = {
    control: (base) => ({
      ...base,
      padding: "0.5rem 0.75rem",
      borderColor: "#d1d5db", // Tailwind border-gray-300
      borderRadius: "0.375rem", // Tailwind rounded-md
      backgroundColor: "#fff", // Tailwind bg-white
      fontSize: "1rem", // Tailwind text-base
    }),
    menu: (base) => ({
      ...base,
      marginTop: "0.25rem",
      borderRadius: "0.375rem", // Tailwind rounded-md
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#6b7280", // Tailwind bg-gray-600
      color: "#fff", // Tailwind text-white
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "#fff", // Tailwind text-white
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "#fff", // Tailwind text-white
      ":hover": {
        backgroundColor: "#f44336", // Tailwind bg-red-500
      },
    }),
  };

  return (
    <div className="w-full max-w-sm mx-auto">
      <Select
        isMulti
        options={filteredOptions.map((opt) => ({ value: opt, label: opt }))}
        value={selectedOptions}
        onChange={handleSelectChange}
        onInputChange={handleSearchChange}
        placeholder={placeholder || "Select Options..."}
        styles={customStyles}
        isClearable={true}
        isSearchable={true}
      />
    </div>
  );
};

export default MultiSelectDropdown;
